import { combineReducers } from 'redux';

import auditorAssetId from './auditorAssetId';

const selected = combineReducers({
  auditorAssetId,
});

export default selected;
